// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ukg0","tabsBox":"styles_tabsBox__2rH3m","createButton":"styles_createButton__3wVvw"};